import { useCurrencyContext } from '@components/Contexts/CurrencyContext';

const usePriceTaxExclusiveNotice = () => {
  const { isInPriceTaxInclusiveCountry } = useCurrencyContext();

  const isPriceTaxExclusiveNoticeShown = !isInPriceTaxInclusiveCountry;

  return {
    isPriceTaxExclusiveNoticeShown,
  };
};

export default usePriceTaxExclusiveNotice;
